import { Directive, ElementRef, inject } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[tellentTheme]',
})
export class TellentThemeDirective {
  #elRef = inject(ElementRef);

  public ngOnInit() {
    this.#elRef.nativeElement.dataset.theme = 'light';
  }
}
